import TtamAdText from './textarea/index.vue';
import TtamAdTextLabel from './label/index.vue';
import TtamAdTextCheck from './check/index.vue';
import TtamAdTextSmart from './smart-text/index.vue';
import TtamAdTextTypoModel from './typo-model/index.vue';
import TtamAdTextComposeWords from './catalog-words/index.vue';
import TtamAdTextLite from './textarea/index-lite.vue';

import * as hooks from './hooks';

import { genSmartTextTrackParams } from './../../common/creative-tool-smart-text-drawer/hooks';
import { useTrackTitleSuggestion } from './../../common/creative-title-suggestion/use-track-title-suggestion';

export default {
  TtamAdText,
  TtamAdTextLabel,
  TtamAdTextCheck,
  TtamAdTextLite,
  TtamAdTextSmart,
  TtamAdTextTypoModel,
  TtamAdTextComposeWords,
  genSmartTextTrackParams,
  useTrackTitleSuggestion,
  ...hooks,
};
